import { motion } from "framer-motion";
import { GiftIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
const bonuses = [{
  n: "Bono #1",
  t: "Manual de Comunicación Clínica con el Técnico",
  d: "Más de 80 instrucciones profesionales listas para copiar y pegar que te ayudarán a comunicar exactamente lo que deseas en cada planificación y evitar errores por mala interpretación.",
  value: "$37 USD",
  img: "https://cdn.magicpatterns.com/uploads/jpbZ34vAzg6VpJKgonHQTw/bono_1_dentistas.png"
}, {
  n: "Bono #2",
  t: "Checklist de Aprobación Clínica",
  d: "Los 12 errores que debes detectar antes de aprobar un caso. Una lista de verificación que completas en menos de 3 minutos para evitar refinamientos innecesarios.",
  value: "$27 USD",
  img: "https://cdn.magicpatterns.com/uploads/m9phWP2tWBm93qThFfWcE2/bono_2_dentistas.png"
}, {
  n: "Bono #3",
  t: "Protocolo de Fotografía Clínica para Alineadores",
  d: "Aprende exactamente cómo tomar las fotografías que permiten obtener planificaciones más precisas desde el primer envío.",
  value: "$29 USD",
  img: "https://cdn.magicpatterns.com/uploads/6JEjUvt79CbRj7yvWdXy7u/bono_3_dentistas.png"
}, {
  n: "Bono #4",
  t: "Dashboard de Seguimiento Clínico del Paciente",
  d: "Una plantilla profesional para monitorear visualmente el progreso del tratamiento y detectar desviaciones antes de que comprometan el resultado.",
  value: "$24 USD",
  img: "https://cdn.magicpatterns.com/uploads/5kxgZNdZ276ip5KFtkHh13/bono_4_dentistas.png"
}, {
  n: "Bono #5",
  t: "Scripts de Comunicación Clínica de Alto Impacto",
  d: "Respuestas listas para explicar IPR, attachments, refinamientos y tiempos de tratamiento de forma clara, aumentando la confianza del paciente y reduciendo objeciones.",
  value: "$37 USD",
  img: "https://cdn.magicpatterns.com/uploads/xAk5uKDSnL6LPBoCLTQDbZ/bono_5_dentistas.png"
}];
export function Bonuses() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-48" data-mp="3cjfylch1gpix">
      <div className="mx-auto max-w-lg px-5 sm:max-w-3xl lg:max-w-5xl" data-id="element-49" data-mp="3cl0t523cs8gs">
        <div className="mx-auto max-w-2xl text-center" data-id="element-50" data-mp="3hgogrd26stk6">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#f5a623]/15 px-3 py-1 text-xs font-700 uppercase tracking-wider text-[#c47d09]" data-id="element-51" data-mp="3ljum8ihh6gpl">
            <GiftIcon className="h-3.5 w-3.5" data-id="element-52" data-mp="3qhwg7ygfw0fu" /> Bonos exclusivos
          </span>
          <h2 className="mt-3 font-head text-2xl font-800 leading-tight text-[#0f2547] sm:text-3xl lg:text-4xl" data-id="element-53" data-mp="2ttq46qh6u5rj">
            Además, hoy recibirás 5 bonos exclusivos totalmente GRATIS
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-slate-500 sm:text-base" data-id="element-54" data-mp="32sbkeez6t8p5">
            Diseñados para ayudarte a planificar mejor, comunicarte con mayor
            precisión y reducir errores desde tu próximo caso.
          </p>
        </div>

        <div className="mt-9 space-y-4" data-id="element-55" data-mp="2f30q9gccecjz">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: 0.05
        }} className="flex flex-col gap-4 overflow-hidden rounded-2xl border border-slate-100 bg-slate-50 p-5 sm:flex-row sm:items-center sm:p-6" data-id="element-56" data-mp="27jzu5g3vfl6n" data-mpi={i}>
              <div className="flex w-full shrink-0 items-center justify-center rounded-2xl bg-white p-2 sm:w-[15rem] sm:p-3 lg:w-[17rem]" data-id="element-57" data-mp="1ol5i4evskyu6">
                <img src={b.img} alt={b.t} className="h-auto w-full max-w-[22rem] object-contain drop-shadow-xl sm:max-w-none" data-id="element-58" data-mp="1jtne1hyh2i4z" />
              </div>

              <div className="flex-1" data-id="element-59" data-mp="19y2io2nwsg47">
                <span className="inline-block rounded-full bg-[#0f2547] px-3 py-1 font-head text-xs font-800 uppercase tracking-wide text-white" data-id="element-60" data-mp="15ueapivd7iif">
                  🎁 {b.n}
                </span>
                <h3 className="mt-2 font-head text-base font-800 leading-snug text-[#0f2547] sm:text-lg" data-id="element-61" data-mp="30xsv9lptuy8a">
                  {b.t}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-500" data-id="element-62" data-mp="34yw7ly8o2c4r">
                  {b.d}
                </p>
              </div>

              <div className="flex shrink-0 flex-row items-center gap-3 sm:flex-col sm:items-end sm:self-center" data-id="element-63" data-mp="2w741u0ul7r6i">
                <span className="text-sm text-slate-400 line-through" data-id="element-64" data-mp="2ha3ahygb5y8k">
                  Valor: {b.value}
                </span>
                <span className="rounded-lg bg-[#f5a623] px-3 py-1 font-head text-sm font-800 uppercase text-[#0a1a34]" data-id="element-65" data-mp="2m9zf9zwtxtp6">
                  Hoy Gratis
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}